import styled from "@emotion/styled";
import { ReactComponent as ViewChartIcon } from "assets/images/svg/chart-icon.svg";

export const ChartIcon = styled(ViewChartIcon)(
  ({ theme }) => `
    fill: ${theme.palette.primary.main};
        height: 18px;
        width: 18px;
    `
);
